<template>
  <div>
    <b-modal
      size="lg"
      centered
      ok-title="Enviar"
      id="modal-erros-idp"
      modal
      @hide="closeModal"
      :title="$ml.get('help')"
    >
      <!-- Lista paginada de erros -->
      <div class="input-group mb-4">
        <input
          class="form-control filterInput"
          v-model="searchError"
          :placeholder="$ml.get('search')"
          aria-label="Search"
          style="border-right: none"
        />
        <div class="input-group-append">
          <div class="input-group-text" style="background-color: #fff">
            <svg width="20" height="20" class="mt-1">
              <image
                xlink:href="../../assets/icons/search_s.svg"
                width="18"
                height="18"
              />
            </svg>
          </div>
        </div>
      </div>
      <div v-if="!paginatedErros.length">
        <p class="error-empety">Nenhum um erro encontrado</p>
      </div>
      <div v-else>
        <div
          v-for="(erro, index) in paginatedErros"
          :key="index"
          class="container-error mb-2"
        >
          <div class="error-idp">
            <div class="mr-1">
              <div class="info-fill-idp">
                <svg width="18" height="18">
                  <image
                    xlink:href="../../assets/svg/info-fill-idp.svg"
                    width="18"
                    height="18"
                  />
                </svg>
              </div>
            </div>
            <span>{{ erro.error }}</span>
          </div>
          <div class="error-section">
            <div class="d-flex align-items-center" style="gap: 10px">
              <svg width="18" height="18">
                <image
                  xlink:href="../../../src/assets/svg/info-fill.svg"
                  width="18"
                  height="18"
                />
              </svg>
              <strong class="title-error-idp">Causa</strong>
            </div>
            <p class="description-error-idp">{{ erro.cause }}</p>
          </div>
          <div class="error-section">
            <div class="d-flex align-items-center" style="gap: 4px">
              <svg width="18" height="18">
                <image
                  xlink:href="../../../src/assets/svg/settings-fill.svg"
                  width="18"
                  height="18"
                />
              </svg>
              <strong class="title-error-idp">Solução</strong>
            </div>
            <p class="description-error-idp">{{ erro.solution }}</p>
          </div>
        </div>
      </div>

      <!-- Paginação -->
      <div v-show="totalPages > 1 && errosMap.length" class="p-3">
        <b-pagination
          v-model="currentPage"
          :total-rows="errosMap.length"
          :per-page="pageSize"
          :prev-text="$ml?.get?.('previous') || 'Anterior'"
          :next-text="$ml?.get?.('next') || 'Próxima'"
          align="right"
        />
      </div>

      <template #modal-footer="{ cancel }">
        <b-button
          class="float-right btn-outline-extra"
          size="sm"
          variant="primary"
          @click="$emit('close', cancel())"
        >
          {{ $ml.get("toClose") }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModalErrosIdp",
  data() {
    return {
      searchError: "",
      currentPage: 1,
      pageSize: 2,
      errosMap: [
        {
          error: "Required attribute 'email' is missing or invalid.",
          cause: this.$ml.get('causeFormatUserName'),
          solution: this.$ml.get('solutionFormatUserName'),
        },
         {
          error: this.$ml.get('errorUserNameIdp'),
          cause: this.$ml.get('causeAttributeEmail'),  
          solution:this.$ml.get('solutionAttributeEmail'),
        },
        {
          error: `Signature validation failed or certificate has expired`,
          cause:this.$ml.get('causeCertificate'), 
          solution:
           this.$ml.get('solutionCertificate'),
        },

        {
          error: `Assertion is out of validity period. Check system clocks.`,
          cause: this.$ml.get('causeClocks'),
          solution:this.$ml.get('solutionClocks'),
        },
        {
          error: `Audience restriction mismatch.`,
          cause: this.$ml.get('causeAudienceRestriction'),
          solution: this.$ml.get('solutionAudienceRestriction'),
        },
        {
          error: `Assertion has been replayed. Each assertion must be unique.`,
          cause: this.$ml.get('causeAssertionSAML'),
          solution: this.$ml.get('solutionAssertionSAML'),
        },
        {
          error: `Malformed SAML message.`,
          cause: this.$ml.get('causeMalformed'),
          solution: this.$ml.get('solutionMalformed'),
        },
        {
          error: `SAML assertion is not signed.`,
          cause: this.$ml.get('causeSAMLAssertion'),
          solution: this.$ml.get('solutionSAMLAssertion'),
        },
        {
          error: `RelayState parameter missing or invalid`,
          cause: this.$ml.get('causeRelayState'),
          solution: this.$ml.get('solutionRelayState')
        },
      ],
    };
  },
  computed: {
    filteredErros() {
      if (!this.searchError.trim()) return this.errosMap;

      const term = this.searchError.toLowerCase();
      return this.errosMap.filter((erro) =>
        [erro.error, erro.cause, erro.solution].some((field) =>
          field.toLowerCase().includes(term),
        ),
      );
    },
    totalPages() {
      return Math.ceil(this.filteredErros.length / this.pageSize);
    },
    paginatedErros() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredErros.slice(start, end);
    },
  },
  methods: {
    closeModal() {
      this.currentPage = 1;
    },
  },
};
</script>

<style scoped>
.error-idp {
  display: flex;
  align-items: center;
  gap: 10px;
  border-left: 3px solid #e0352a;
  background: #fff1ef;
  font-weight: 400;
  border-radius: 4px;
  margin-bottom: 14px;
  letter-spacing: 0.8px;
  line-height: 1.5;
  color: #d3312b;
  padding: 10px;
}
.description-error-idp {
  line-height: 1.5;
}

.title-error-idp {
  font-size: 18px;
}

.container-error {
  border: 1px solid #cccccc52;
  border-radius: 4px;
}

.info-fill-idp {
  height: 24px;
  width: 24px;
  background: #dd362c;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
.error-section {
  padding: 10px;
}
.error-empety {
  font-size: 18px;
  text-align: center;
  font-weight: 400;
}
</style>
